import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac6300c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wageBeforeAfterModalCard" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "비과세 적용 전후 비교표", -1))
const _hoisted_4 = { class: "info-section" }
const _hoisted_5 = { class: "info-row" }
const _hoisted_6 = { class: "info-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "조회 연월", -1))
const _hoisted_8 = { class: "info-value highlight" }
const _hoisted_9 = { class: "info-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "서비스 시작연월", -1))
const _hoisted_11 = { class: "info-value" }
const _hoisted_12 = { class: "action-section" }
const _hoisted_13 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "unit-label" }, "단위: 원", -1))
const _hoisted_15 = { class: "comparison-table-wrapper" }
const _hoisted_16 = { class: "comparison-table" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      class: "sticky-col col-no"
    }, "No"),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      class: "sticky-col-name"
    }, "사원명"),
    /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "직종"),
    /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "총급여"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "4",
      class: "before-header"
    }, "개선전"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "4",
      class: "after-header"
    }, "개선후"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "4",
      class: "diff-header"
    }, "차액"),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      class: "saving-header"
    }, "절감액")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "before-header" }, "비과세"),
    /*#__PURE__*/_createElementVNode("th", { class: "before-header" }, "기관부담"),
    /*#__PURE__*/_createElementVNode("th", { class: "before-header" }, "퇴직금"),
    /*#__PURE__*/_createElementVNode("th", { class: "before-header" }, "지급급여"),
    /*#__PURE__*/_createElementVNode("th", { class: "after-header" }, "비과세"),
    /*#__PURE__*/_createElementVNode("th", { class: "after-header" }, "기관부담"),
    /*#__PURE__*/_createElementVNode("th", { class: "after-header" }, "퇴직금"),
    /*#__PURE__*/_createElementVNode("th", { class: "after-header" }, "지급급여"),
    /*#__PURE__*/_createElementVNode("th", { class: "diff-sub-header" }, "비과세"),
    /*#__PURE__*/_createElementVNode("th", { class: "diff-sub-header" }, "기관부담"),
    /*#__PURE__*/_createElementVNode("th", { class: "diff-sub-header" }, "퇴직금"),
    /*#__PURE__*/_createElementVNode("th", { class: "diff-sub-header" }, "지급급여")
  ])
], -1))
const _hoisted_18 = { class: "sticky-col col-no text-center" }
const _hoisted_19 = { class: "sticky-col-name" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = ["title"]
const _hoisted_22 = ["title"]
const _hoisted_23 = ["title"]
const _hoisted_24 = ["title"]
const _hoisted_25 = ["title"]
const _hoisted_26 = ["title"]
const _hoisted_27 = ["title"]
const _hoisted_28 = ["title"]
const _hoisted_29 = ["title"]
const _hoisted_30 = ["title"]
const _hoisted_31 = ["title"]
const _hoisted_32 = ["title"]
const _hoisted_33 = ["title"]
const _hoisted_34 = ["title"]
const _hoisted_35 = { class: "total-row" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "sticky-col col-no font-bold",
  colspan: "3"
}, "합계", -1))
const _hoisted_37 = { class: "text-right font-bold" }
const _hoisted_38 = { class: "before-cell text-right font-bold" }
const _hoisted_39 = { class: "before-cell text-right font-bold" }
const _hoisted_40 = { class: "before-cell text-right font-bold" }
const _hoisted_41 = { class: "before-cell text-right font-bold" }
const _hoisted_42 = { class: "after-cell text-right font-bold" }
const _hoisted_43 = { class: "after-cell text-right font-bold" }
const _hoisted_44 = { class: "after-cell text-right font-bold" }
const _hoisted_45 = { class: "after-cell text-right font-bold" }
const _hoisted_46 = ["title"]
const _hoisted_47 = ["title"]
const _hoisted_48 = ["title"]
const _hoisted_49 = ["title"]
const _hoisted_50 = ["title"]
const _hoisted_51 = { class: "summary-section" }
const _hoisted_52 = { class: "summary-cards" }
const _hoisted_53 = { class: "summary-card before-card" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "개선전 (생산직비과세 미적용)", -1))
const _hoisted_55 = { class: "summary-row" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "총급여", -1))
const _hoisted_57 = { class: "value" }
const _hoisted_58 = { class: "summary-row" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "비과세", -1))
const _hoisted_60 = { class: "value" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_62 = { class: "summary-row" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "기관부담 4대보험", -1))
const _hoisted_64 = { class: "value" }
const _hoisted_65 = { class: "summary-row" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "퇴직금", -1))
const _hoisted_67 = { class: "value" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_69 = { class: "summary-row total" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "지급급여 (실수령액)", -1))
const _hoisted_71 = { class: "value" }
const _hoisted_72 = { class: "summary-card after-card" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "개선후 (생산직비과세 적용)", -1))
const _hoisted_74 = { class: "summary-row" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "총급여", -1))
const _hoisted_76 = { class: "value" }
const _hoisted_77 = { class: "summary-row" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "비과세", -1))
const _hoisted_79 = { class: "value" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_81 = { class: "summary-row" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "기관부담 4대보험", -1))
const _hoisted_83 = { class: "value" }
const _hoisted_84 = { class: "summary-row" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "퇴직금", -1))
const _hoisted_86 = { class: "value" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_88 = { class: "summary-row total" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "지급급여 (실수령액)", -1))
const _hoisted_90 = { class: "value" }
const _hoisted_91 = { class: "summary-card diff-card" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "기관 비용 절감 효과", -1))
const _hoisted_93 = { class: "summary-row highlight-row" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "대상 인원", -1))
const _hoisted_95 = { class: "value" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_97 = { class: "summary-row" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "기관부담 4대보험 차액", -1))
const _hoisted_99 = { class: "summary-row" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "퇴직금 차액", -1))
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_102 = { class: "summary-row total" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "월 절감액", -1))
const _hoisted_104 = { class: "summary-row info" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "연간 절감 예상액", -1))
const _hoisted_106 = {
  key: 1,
  class: "modal-content empty-state"
}
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "데이터가 없습니다.", -1))
const _hoisted_108 = [
  _hoisted_107
]
const _hoisted_109 = {
  key: 2,
  class: "modal-content empty-state"
}
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "데이터를 불러오는 중...", -1))
const _hoisted_111 = [
  _hoisted_110
]
const _hoisted_112 = { class: "modal-footer" }

import { ref, reactive } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import WageBeforeAfterHelp from "./WageBeforeAfterHelp.vue";

interface LedgerItem {
  empName: string;
  empJob: string;
  empNum: string;
  sisulName: string;
  ym: string;
  total: string;
  taxable: string;
  dang: string;
  lunch: string;
  car: string;
  childcare: string;
  l_yeon: string;
  l_gun: string;
  l_jang: string;
  l_go: string;
  l_so: string;
  l_ji: string;
  l_jiwon: string;
  l_sik: string;
  l_etc: string;
  l_yearEnd: string;
  l_total: string;
  c_yeon: string;
  c_gun: string;
  c_jang: string;
  c_go: string;
  c_sil: string;
  c_san: string;
  c_out: string;
  empOutYm?: string;
}

interface TaxRate {
  tr_yeon: number;
  tr_gun: number;
  tr_jang: number;
  tr_go: number;
  tr_sil: number;
  tr_san: number;
}

interface BasicItem {
  empName: string;
  empJob: string;
  empNum: string;
  eaBasicPay: string;
  eaOverPay: string;
  eaNightPay: string;
  eaHolidayPay: string;
  eaDayOffPay: string;
  eaLongtermPay: string;
  eaSunimPay: string;
  eaBonus: string;
  eaEduPay: string;
  eaBojonPay: string;
  eaEtcPay: string;
  eaDangPay: string;
  eaLunchPay: string;
  eaCarPay: string;
  eaChildcarePay: string;
  eaMealDeduct: string;
  eaEtcDeduct: string;
  eaYearEnd: string;
}

interface ComparisonItem {
  empName: string;
  empJob: string;
  total: string;
  before: {
    nonTax: string;
    companyIns: string;
    retirement: string;
    netPay: string;
  };
  after: {
    nonTax: string;
    companyIns: string;
    retirement: string;
    netPay: string;
  };
  diff: {
    nonTax: string;
    companyIns: string;
    retirement: string;
    netPay: string;
  };
  saving: string;
  tooltip: {
    total: string;
    beforeNonTax: string;
    beforeCompanyIns: string;
    beforeRetirement: string;
    beforeNetPay: string;
    afterNonTax: string;
    afterCompanyIns: string;
    afterRetirement: string;
    afterNetPay: string;
    diffNonTax: string;
    diffCompanyIns: string;
    diffRetirement: string;
    diffNetPay: string;
    saving: string;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WageBeforeAfter',
  props: {
    wageList: {},
    tax: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const store = useStore();
const dialog = ref(false);
const activeTab = ref("detail");
const loadingBasic = ref(false);
const basicList = ref<BasicItem[]>([]);
const comparisonData = ref<ComparisonItem[]>([]);

// 서비스 시작연월 관련
const serviceStartDate = ref<string>("");
const rawServiceStartYm = ref<string>(""); // YYYY-MM 형식
const isEditingServiceDate = ref(false);
const editServiceDate = ref("");
const isSavingDate = ref(false);
const currentYearMonth = ref("");
const rawCurrentYm = ref<string>(""); // YYYY-MM 형식

const totals = reactive({
  total: "0",
  before: {
    nonTax: "0", companyIns: "0", retirement: "0", netPay: "0"
  },
  after: {
    nonTax: "0", companyIns: "0", retirement: "0", netPay: "0"
  },
  diff: {
    nonTax: "0", companyIns: "0", retirement: "0", netPay: "0"
  },
  saving: "0",
  yearSaving: "0"
});

const totalsTooltip = reactive({
  nonTax: "",
  companyIns: "",
  retirement: "",
  netPay: "",
  saving: ""
});

const openDialog = async () => {
  dialog.value = true;
  activeTab.value = "detail";
  comparisonData.value = [];
  rawCurrentYm.value = store.state.AdminYYMM;
  currentYearMonth.value = formatYearMonth(store.state.AdminYYMM);
  await fetchServiceStartDate();
  await fetchBasicData();
};

__expose({ openDialog });

const closeDialog = () => {
  dialog.value = false;
};

const nc = (value: string | number | null | undefined): number => {
  if (value == null) return 0;
  return parseFloat(value.toString().replace(/,/g, "")) || 0;
};

const ac = (value: number): string => {
  if (isNaN(value)) return "0";
  return Math.round(value).toLocaleString();
};

const getDiffClass = (value: string, isReverse = false): string => {
  const num = nc(value);
  if (isReverse) {
    if (num < 0) return "highlight-green";
    if (num > 0) return "highlight-red";
  } else {
    if (num > 0) return "highlight-green";
    if (num < 0) return "highlight-red";
  }
  return "";
};

const formatYearMonth = (ym: string): string => {
  if (!ym) return "";
  const parts = ym.split("-");
  if (parts.length === 2) {
    return `${parts[0]}년 ${parseInt(parts[1], 10)}월`;
  }
  return ym;
};

const fetchServiceStartDate = async () => {
  try {
    const sisulId = store.state.AdminSisulId;
    const response = await axios.get(`/api/readSsId/${sisulId}`);
    if (response.data?.result) {
      const wageIn = response.data.result.sisul_wage_in;
      serviceStartDate.value = wageIn ? formatYearMonth(wageIn) : "";
      rawServiceStartYm.value = wageIn || "";
      editServiceDate.value = wageIn || "";
    }
  } catch (error) {
    console.error("서비스 시작연월 조회 실패:", error);
  }
};

const saveServiceDate = async () => {
  if (!editServiceDate.value) return;
  isSavingDate.value = true;
  try {
    const sisulId = store.state.AdminSisulId;
    await axios.post("/api/updateSsWageIn", {
      sisul_id: sisulId,
      sisul_wage_in: editServiceDate.value
    });
    serviceStartDate.value = formatYearMonth(editServiceDate.value);
    rawServiceStartYm.value = editServiceDate.value;
    isEditingServiceDate.value = false;
    store.commit("showSnackbar", { text: "서비스 시작연월이 저장되었습니다.", color: "success" });
    calculateComparison();
  } catch (error) {
    console.error("서비스 시작연월 저장 실패:", error);
    store.commit("showSnackbar", { text: "저장 중 오류가 발생했습니다.", color: "error" });
  } finally {
    isSavingDate.value = false;
  }
};

const cancelEditServiceDate = () => {
  isEditingServiceDate.value = false;
  const ym = store.state.AdminYYMM;
  editServiceDate.value = serviceStartDate.value ? ym : "";
};

const fetchBasicData = async () => {
  loadingBasic.value = true;
  try {
    const code = store.state.AdminSisulCode;
    const date = store.state.AdminYYMM;
    const response = await axios.get(`/api/getEmpWageBasic/${code}/${date}`);
    if (response.data?.result) {
      basicList.value = response.data.result;
      calculateComparison();
    }
  } catch (error) {
    console.error("임금기초 데이터 로드 실패:", error);
  } finally {
    loadingBasic.value = false;
  }
};

const calculateComparison = () => {
  if (!props.wageList || props.wageList.length === 0) return;
  if (!basicList.value || basicList.value.length === 0) return;

  const taxRate = props.tax;

  const sum = { total: 0 };
  const sumBefore = { nonTax: 0, companyIns: 0, retirement: 0, netPay: 0 };
  const sumAfter = { nonTax: 0, companyIns: 0, retirement: 0, netPay: 0 };

  // 서비스 시작연월 이전에 퇴사한 직원 제외
  const filteredWageList = rawServiceStartYm.value
    ? props.wageList.filter((ledger) => !ledger.empOutYm || ledger.empOutYm >= rawServiceStartYm.value)
    : props.wageList;

  comparisonData.value = filteredWageList.map((ledger) => {
    const basic = basicList.value.find((b) => b.empNum === ledger.empNum);

    // 총급여 (개선전/개선후 동일하게 afterTotal 사용)
    const total = nc(ledger.total);

    // 개선후 (임금대장 데이터)
    const afterTaxable = nc(ledger.taxable);
    const afterNonTax = total - afterTaxable;
    const afterDeduction = nc(ledger.l_total);
    const afterNetPay = total - afterDeduction;
    const afterRetirement = nc(ledger.c_out);

    // 개선후 기관부담 4대보험
    const after_c_yeon = nc(ledger.c_yeon);
    const after_c_gun = nc(ledger.c_gun);
    const after_c_jang = nc(ledger.c_jang);
    const after_c_go = nc(ledger.c_go);
    const after_c_sil = nc(ledger.c_sil);
    const after_c_san = nc(ledger.c_san);
    const afterCompanyIns = after_c_yeon + after_c_gun + after_c_jang + after_c_go + after_c_sil + after_c_san;

    // 개선전 변수
    let beforeNonTax = 0;
    let beforeTaxable = 0;
    let beforeDeduction = 0;
    let beforeNetPay = 0;
    let beforeCompanyIns = 0;
    let beforeRetirement = 0;

    let before_c_yeon = 0, before_c_gun = 0, before_c_jang = 0, before_c_go = 0, before_c_sil = 0, before_c_san = 0;
    let beforeLunchPay = 0;

    // 개선후 비과세 항목 (임금대장)
    const afterDang = nc(ledger.dang);
    const afterLunch = nc(ledger.lunch);
    const afterCar = nc(ledger.car);
    const afterChildcare = nc(ledger.childcare);
    const afterProductionNonTax = afterNonTax - afterDang - afterLunch - afterCar - afterChildcare;

    // 개선전 비과세 항목
    let beforeDangPay = 0, beforeCarPay = 0, beforeChildcarePay = 0;

    if (basic) {
      beforeDangPay = nc(basic.eaDangPay);
      beforeLunchPay = nc(basic.eaLunchPay);
      beforeCarPay = nc(basic.eaCarPay);
      beforeChildcarePay = nc(basic.eaChildcarePay);

      // 개선전 비과세 (생산직비과세 미적용 - 당직+중식+차량+양육만)
      beforeNonTax = Math.floor((beforeLunchPay + beforeCarPay + beforeChildcarePay + beforeDangPay) / 10) * 10;
      beforeTaxable = Math.floor((total - beforeNonTax) / 10) * 10;

      // 개선전 근로자 공제 (개선후와 동일하게 사용)
      beforeDeduction = afterDeduction;
      beforeNetPay = total - beforeDeduction;

      // 개선전 기관부담 4대보험 계산
      before_c_yeon = after_c_yeon;
      before_c_gun = after_c_gun === 0 ? 0 : Math.max(after_c_gun, Math.floor((beforeTaxable * taxRate.tr_gun) / 10) * 10);
      before_c_jang = after_c_jang === 0 ? 0 : Math.max(after_c_jang, Math.floor((before_c_gun * taxRate.tr_jang) / 10) * 10);
      before_c_go = after_c_go === 0 ? 0 : Math.max(after_c_go, Math.floor((beforeTaxable * taxRate.tr_go) / 10) * 10);
      before_c_sil = after_c_sil === 0 ? 0 : Math.max(after_c_sil, Math.floor((beforeTaxable * taxRate.tr_sil) / 10) * 10);
      before_c_san = after_c_san;

      beforeCompanyIns = before_c_yeon + before_c_gun + before_c_jang + before_c_go + before_c_sil + before_c_san;
      beforeRetirement = afterRetirement === 0 ? 0 : Math.floor(((total - beforeLunchPay) / 12) / 10) * 10;
    }

    // 차액 계산
    const diffNonTax = afterNonTax - beforeNonTax;
    const diffCompanyIns = afterCompanyIns - beforeCompanyIns;
    const diffRetirement = afterRetirement - beforeRetirement;
    const diffNetPay = afterNetPay - beforeNetPay;
    const saving = diffCompanyIns + diffRetirement;

    // 툴팁 생성 (자세한 내역 포함)
    const tooltipTotal = `[총급여]\n\n◆ 임금대장 총급여\n= ${ac(total)}`;

    const tooltipBeforeNonTax = `[개선전 비과세]\n\n` +
      `※ 생산직비과세 미적용\n\n` +
      `◆ 비과세 항목\n` +
      `  당직수당: ${ac(beforeDangPay)}\n` +
      `  중식대: ${ac(beforeLunchPay)}\n` +
      `  차량비: ${ac(beforeCarPay)}\n` +
      `  양육비: ${ac(beforeChildcarePay)}\n` +
      `━━━━━━━━━━━━━━━━━━━━\n` +
      `= 비과세 합계: ${ac(beforeNonTax)}`;

    const tooltipBeforeCompanyIns = `[개선전 기관부담 4대보험]\n\n` +
      `◆ 과세금액 ${ac(beforeTaxable)} 기준\n\n` +
      `  국민연금: ${ac(before_c_yeon)}${before_c_yeon === 0 ? ' (면제)' : ''}\n` +
      `  건강보험: ${ac(before_c_gun)}${before_c_gun === 0 ? ' (면제)' : ''}\n` +
      `  장기요양: ${ac(before_c_jang)}${before_c_jang === 0 ? ' (면제)' : ''}\n` +
      `  고용보험: ${ac(before_c_go)}${before_c_go === 0 ? ' (면제)' : ''}\n` +
      `  실업급여: ${ac(before_c_sil)}${before_c_sil === 0 ? ' (면제)' : ''}\n` +
      `  산재보험: ${ac(before_c_san)}${before_c_san === 0 ? ' (면제)' : ''}\n` +
      `━━━━━━━━━━━━━━━━━━━━\n` +
      `= 기관부담 합계: ${ac(beforeCompanyIns)}`;

    const tooltipBeforeRetirement = `[개선전 퇴직금]\n\n` +
      `◆ 계산식\n  (총급여 - 중식대) ÷ 12\n\n` +
      `◆ 산출내역\n` +
      `  총급여: ${ac(total)}\n` +
      `  (-) 중식대: ${ac(beforeLunchPay)}\n` +
      `  = ${ac(total - beforeLunchPay)} ÷ 12\n` +
      `━━━━━━━━━━━━━━━━━━━━\n` +
      `= 퇴직금: ${ac(beforeRetirement)}${afterRetirement === 0 ? ' (면제)' : ''}`;

    const tooltipBeforeNetPay = `[개선전 지급급여]\n\n` +
      `◆ 계산식\n  총급여 - 근로자공제 = 지급급여\n\n` +
      `◆ 산출내역\n` +
      `  총급여: ${ac(total)}\n` +
      `  (-) 근로자공제: ${ac(beforeDeduction)}\n` +
      `━━━━━━━━━━━━━━━━━━━━\n` +
      `= 지급급여: ${ac(beforeNetPay)}`;

    const tooltipAfterNonTax = `[개선후 비과세]\n\n` +
      `※ 생산직비과세 적용\n\n` +
      `◆ 비과세 항목\n` +
      `  생산직비과세: ${ac(afterProductionNonTax)}\n` +
      `  당직수당: ${ac(afterDang)}\n` +
      `  중식대: ${ac(afterLunch)}\n` +
      `  차량비: ${ac(afterCar)}\n` +
      `  양육비: ${ac(afterChildcare)}\n` +
      `━━━━━━━━━━━━━━━━━━━━\n` +
      `= 비과세 합계: ${ac(afterNonTax)}`;

    const tooltipAfterCompanyIns = `[개선후 기관부담 4대보험]\n\n` +
      `◆ 과세금액 ${ac(afterTaxable)} 기준\n\n` +
      `  국민연금: ${ac(after_c_yeon)}${after_c_yeon === 0 ? ' (면제)' : ''}\n` +
      `  건강보험: ${ac(after_c_gun)}${after_c_gun === 0 ? ' (면제)' : ''}\n` +
      `  장기요양: ${ac(after_c_jang)}${after_c_jang === 0 ? ' (면제)' : ''}\n` +
      `  고용보험: ${ac(after_c_go)}${after_c_go === 0 ? ' (면제)' : ''}\n` +
      `  실업급여: ${ac(after_c_sil)}${after_c_sil === 0 ? ' (면제)' : ''}\n` +
      `  산재보험: ${ac(after_c_san)}${after_c_san === 0 ? ' (면제)' : ''}\n` +
      `━━━━━━━━━━━━━━━━━━━━\n` +
      `= 기관부담 합계: ${ac(afterCompanyIns)}`;

    const tooltipAfterRetirement = `[개선후 퇴직금]\n\n` +
      `◆ 임금대장 퇴직금\n` +
      `━━━━━━━━━━━━━━━━━━━━\n` +
      `= 퇴직금: ${ac(afterRetirement)}${afterRetirement === 0 ? ' (면제)' : ''}`;

    const tooltipAfterNetPay = `[개선후 지급급여]\n\n` +
      `◆ 계산식\n  총급여 - 근로자공제 = 지급급여\n\n` +
      `◆ 산출내역\n` +
      `  총급여: ${ac(total)}\n` +
      `  (-) 근로자공제: ${ac(afterDeduction)}\n` +
      `━━━━━━━━━━━━━━━━━━━━\n` +
      `= 지급급여: ${ac(afterNetPay)}`;

    const diffNonTaxStatus = diffNonTax > 0 ? '✓ 비과세 증가 (좋음)' : (diffNonTax < 0 ? '⚠ 비과세 감소' : '→ 변동 없음');
    const tooltipDiffNonTax = `[비과세 차액]\n\n` +
      `◆ 개선후 - 개선전 = 차액\n\n` +
      `  개선전: ${ac(beforeNonTax)}\n` +
      `  개선후: ${ac(afterNonTax)}\n` +
      `━━━━━━━━━━━━━━━━━━━━\n` +
      `= 차액: ${ac(diffNonTax)}\n\n` +
      `${diffNonTaxStatus}`;

    const diffCompanyInsStatus = diffCompanyIns < 0 ? '✓ 기관부담 감소 (절감)' : (diffCompanyIns > 0 ? '⚠ 기관부담 증가' : '→ 변동 없음');
    const tooltipDiffCompanyIns = `[기관부담 차액]\n\n` +
      `◆ 개선후 - 개선전 = 차액\n\n` +
      `◆ 항목별 차액\n` +
      `  국민연금: ${ac(after_c_yeon - before_c_yeon)}\n` +
      `  건강보험: ${ac(after_c_gun - before_c_gun)}\n` +
      `  장기요양: ${ac(after_c_jang - before_c_jang)}\n` +
      `  고용보험: ${ac(after_c_go - before_c_go)}\n` +
      `  실업급여: ${ac(after_c_sil - before_c_sil)}\n` +
      `  산재보험: ${ac(after_c_san - before_c_san)}\n` +
      `━━━━━━━━━━━━━━━━━━━━\n` +
      `= 차액: ${ac(diffCompanyIns)}\n\n` +
      `${diffCompanyInsStatus}`;

    const diffRetirementStatus = diffRetirement < 0 ? '✓ 퇴직금 감소 (절감)' : (diffRetirement > 0 ? '⚠ 퇴직금 증가' : '→ 변동 없음');
    const tooltipDiffRetirement = `[퇴직금 차액]\n\n` +
      `◆ 개선후 - 개선전 = 차액\n\n` +
      `  개선전: ${ac(beforeRetirement)}\n` +
      `  개선후: ${ac(afterRetirement)}\n` +
      `━━━━━━━━━━━━━━━━━━━━\n` +
      `= 차액: ${ac(diffRetirement)}\n\n` +
      `${diffRetirementStatus}`;

    const diffNetPayStatus = diffNetPay > 0 ? '✓ 지급급여 증가 (좋음)' : (diffNetPay < 0 ? '⚠ 지급급여 감소' : '→ 변동 없음');
    const tooltipDiffNetPay = `[지급급여 차액]\n\n` +
      `◆ 개선후 - 개선전 = 차액\n\n` +
      `  개선전: ${ac(beforeNetPay)}\n` +
      `  개선후: ${ac(afterNetPay)}\n` +
      `━━━━━━━━━━━━━━━━━━━━\n` +
      `= 차액: ${ac(diffNetPay)}\n\n` +
      `${diffNetPayStatus}`;

    const savingStatus = saving < 0 ? '✓ 기관비용 절감' : (saving > 0 ? '⚠ 기관비용 증가' : '→ 변동 없음');
    const tooltipSaving = `[기관 절감액]\n\n` +
      `◆ 기관부담 차액 + 퇴직금 차액\n\n` +
      `  기관부담 차액: ${ac(diffCompanyIns)}\n` +
      `  퇴직금 차액: ${ac(diffRetirement)}\n` +
      `━━━━━━━━━━━━━━━━━━━━\n` +
      `= 절감액: ${ac(saving)}\n\n` +
      `${savingStatus}`;

    sum.total += total;
    sumBefore.nonTax += beforeNonTax;
    sumBefore.companyIns += beforeCompanyIns;
    sumBefore.retirement += beforeRetirement;
    sumBefore.netPay += beforeNetPay;
    sumAfter.nonTax += afterNonTax;
    sumAfter.companyIns += afterCompanyIns;
    sumAfter.retirement += afterRetirement;
    sumAfter.netPay += afterNetPay;

    return {
      empName: ledger.empName,
      empJob: ledger.empJob || "",
      total: ac(total),
      before: {
        nonTax: ac(beforeNonTax),
        companyIns: ac(beforeCompanyIns),
        retirement: ac(beforeRetirement),
        netPay: ac(beforeNetPay)
      },
      after: {
        nonTax: ac(afterNonTax),
        companyIns: ac(afterCompanyIns),
        retirement: ac(afterRetirement),
        netPay: ac(afterNetPay)
      },
      diff: {
        nonTax: ac(diffNonTax),
        companyIns: ac(diffCompanyIns),
        retirement: ac(diffRetirement),
        netPay: ac(diffNetPay)
      },
      saving: ac(saving),
      tooltip: {
        total: tooltipTotal,
        beforeNonTax: tooltipBeforeNonTax,
        beforeCompanyIns: tooltipBeforeCompanyIns,
        beforeRetirement: tooltipBeforeRetirement,
        beforeNetPay: tooltipBeforeNetPay,
        afterNonTax: tooltipAfterNonTax,
        afterCompanyIns: tooltipAfterCompanyIns,
        afterRetirement: tooltipAfterRetirement,
        afterNetPay: tooltipAfterNetPay,
        diffNonTax: tooltipDiffNonTax,
        diffCompanyIns: tooltipDiffCompanyIns,
        diffRetirement: tooltipDiffRetirement,
        diffNetPay: tooltipDiffNetPay,
        saving: tooltipSaving
      }
    };
  });

  const diffNonTax = sumAfter.nonTax - sumBefore.nonTax;
  const diffCompanyIns = sumAfter.companyIns - sumBefore.companyIns;
  const diffRetirement = sumAfter.retirement - sumBefore.retirement;
  const diffNetPay = sumAfter.netPay - sumBefore.netPay;
  const saving = diffCompanyIns + diffRetirement;

  totals.total = ac(sum.total);
  totals.before.nonTax = ac(sumBefore.nonTax);
  totals.before.companyIns = ac(sumBefore.companyIns);
  totals.before.retirement = ac(sumBefore.retirement);
  totals.before.netPay = ac(sumBefore.netPay);
  totals.after.nonTax = ac(sumAfter.nonTax);
  totals.after.companyIns = ac(sumAfter.companyIns);
  totals.after.retirement = ac(sumAfter.retirement);
  totals.after.netPay = ac(sumAfter.netPay);
  totals.diff.nonTax = ac(diffNonTax);
  totals.diff.companyIns = ac(diffCompanyIns);
  totals.diff.retirement = ac(diffRetirement);
  totals.diff.netPay = ac(diffNetPay);
  totals.saving = ac(saving);
  totals.yearSaving = ac(saving * 12);

  generateTotalsTooltip();
};

const generateTotalsTooltip = () => {
  const data = comparisonData.value;

  const nonTaxGood = data.filter(item => nc(item.diff.nonTax) > 0)
    .map(item => `${item.empName}(${item.empJob}): +${item.diff.nonTax}`);

  const companyInsGood = data.filter(item => nc(item.diff.companyIns) < 0)
    .map(item => `${item.empName}(${item.empJob}): ${item.diff.companyIns}`);

  const retirementGood = data.filter(item => nc(item.diff.retirement) < 0)
    .map(item => `${item.empName}(${item.empJob}): ${item.diff.retirement}`);

  const netPayGood = data.filter(item => nc(item.diff.netPay) > 0)
    .map(item => `${item.empName}(${item.empJob}): +${item.diff.netPay}`);

  const savingGood = data.filter(item => nc(item.saving) < 0)
    .map(item => `${item.empName}(${item.empJob}): ${item.saving}`);

  totalsTooltip.nonTax = `[비과세 차액] 합계: ${totals.diff.nonTax}\n` +
    `(+는 비과세 증가로 좋음)\n\n` +
    (nonTaxGood.length > 0 ? `✓ 비과세 증가 (${nonTaxGood.length}명):\n${nonTaxGood.slice(0, 5).join('\n')}${nonTaxGood.length > 5 ? '\n...' : ''}` : '');

  totalsTooltip.companyIns = `[기관부담 차액] 합계: ${totals.diff.companyIns}\n` +
    `(-는 기관부담 감소로 절감)\n\n` +
    (companyInsGood.length > 0 ? `✓ 기관부담 감소 (${companyInsGood.length}명):\n${companyInsGood.slice(0, 5).join('\n')}${companyInsGood.length > 5 ? '\n...' : ''}` : '');

  totalsTooltip.retirement = `[퇴직금 차액] 합계: ${totals.diff.retirement}\n` +
    `(-는 퇴직금 감소로 절감)\n\n` +
    (retirementGood.length > 0 ? `✓ 퇴직금 감소 (${retirementGood.length}명):\n${retirementGood.slice(0, 5).join('\n')}${retirementGood.length > 5 ? '\n...' : ''}` : '');

  totalsTooltip.netPay = `[지급급여 차액] 합계: ${totals.diff.netPay}\n` +
    `(+는 실수령액 증가로 좋음)\n\n` +
    (netPayGood.length > 0 ? `✓ 지급급여 증가 (${netPayGood.length}명):\n${netPayGood.slice(0, 5).join('\n')}${netPayGood.length > 5 ? '\n...' : ''}` : '');

  totalsTooltip.saving = `[기관 절감액] 합계: ${totals.saving}\n` +
    `(-는 비용 절감)\n\n◆ 연간 절감 예상: ${totals.yearSaving}\n\n` +
    (savingGood.length > 0 ? `✓ 비용 절감 (${savingGood.length}명):\n${savingGood.slice(0, 5).join('\n')}${savingGood.length > 5 ? '\n...' : ''}` : '');
};

const generatePdf = async () => {
  try {
    if (comparisonData.value.length === 0) {
      alert("비교 데이터가 없습니다.");
      return;
    }

    const sisulName = props.wageList[0]?.sisulName || "";
    const yearMonth = props.wageList[0]?.ym || "";

    const response = await axios.post("/api/getWageBeforeAfterPdf", {
      comparisonData: comparisonData.value,
      totals: { total: totals.total, before: totals.before, after: totals.after, diff: totals.diff, saving: totals.saving, yearSaving: totals.yearSaving },
      sisulName,
      yearMonth
    });

    const pdfBase64 = response.data.pdf;
    const binaryString = window.atob(pdfBase64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    const blob = new Blob([bytes], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const newWindow = window.open(url, "_blank");
    if (newWindow) {
      newWindow.focus();
    } else {
      alert("팝업 차단 설정을 확인해주세요.");
    }
  } catch (error) {
    console.error("PDF 생성 에러:", error);
    alert("PDF 생성 중 오류가 발생했습니다.");
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialog).value = $event)),
    "max-width": "1400px",
    class: "fontNotoSans400",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_v_icon, {
            class: "close-btn",
            color: "#333",
            onClick: closeDialog
          }, {
            default: _withCtx(() => [
              _createTextVNode("mdi-close")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("span", _hoisted_8, _toDisplayString(currentYearMonth.value), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              (!isEditingServiceDate.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(serviceStartDate.value || '미설정'), 1),
                    _createVNode(_component_v_btn, {
                      variant: "text",
                      size: "x-small",
                      color: "grey",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (isEditingServiceDate.value = true)),
                      class: "edit-btn"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { size: "small" }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-pencil")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "month",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editServiceDate).value = $event)),
                      class: "date-input"
                    }, null, 512), [
                      [_vModelText, editServiceDate.value]
                    ]),
                    _createVNode(_component_v_btn, {
                      variant: "text",
                      size: "x-small",
                      color: "primary",
                      onClick: saveServiceDate,
                      loading: isSavingDate.value
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { size: "small" }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-check")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["loading"]),
                    _createVNode(_component_v_btn, {
                      variant: "text",
                      size: "x-small",
                      color: "grey",
                      onClick: cancelEditServiceDate
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { size: "small" }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-close")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 64))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_v_btn, {
            class: "btnColorDark",
            onClick: generatePdf,
            disabled: comparisonData.value.length === 0
          }, {
            default: _withCtx(() => [
              _createTextVNode("PDF 생성")
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createVNode(WageBeforeAfterHelp),
        (comparisonData.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_v_tabs, {
                modelValue: activeTab.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((activeTab).value = $event)),
                color: "primary"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tab, { value: "detail" }, {
                    default: _withCtx(() => [
                      _createTextVNode("상세 비교")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tab, { value: "summary" }, {
                    default: _withCtx(() => [
                      _createTextVNode("요약")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_v_window, {
                modelValue: activeTab.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((activeTab).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_window_item, { value: "detail" }, {
                    default: _withCtx(() => [
                      _hoisted_14,
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("table", _hoisted_16, [
                          _hoisted_17,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comparisonData.value, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", _hoisted_18, _toDisplayString(index + 1), 1),
                                _createElementVNode("td", _hoisted_19, _toDisplayString(item.empName), 1),
                                _createElementVNode("td", _hoisted_20, _toDisplayString(item.empJob), 1),
                                _createElementVNode("td", {
                                  class: "text-right tooltip-cell",
                                  title: item.tooltip.total
                                }, _toDisplayString(item.total), 9, _hoisted_21),
                                _createElementVNode("td", {
                                  class: "before-cell text-right tooltip-cell",
                                  title: item.tooltip.beforeNonTax
                                }, _toDisplayString(item.before.nonTax), 9, _hoisted_22),
                                _createElementVNode("td", {
                                  class: "before-cell text-right tooltip-cell",
                                  title: item.tooltip.beforeCompanyIns
                                }, _toDisplayString(item.before.companyIns), 9, _hoisted_23),
                                _createElementVNode("td", {
                                  class: "before-cell text-right tooltip-cell",
                                  title: item.tooltip.beforeRetirement
                                }, _toDisplayString(item.before.retirement), 9, _hoisted_24),
                                _createElementVNode("td", {
                                  class: "before-cell text-right tooltip-cell",
                                  title: item.tooltip.beforeNetPay
                                }, _toDisplayString(item.before.netPay), 9, _hoisted_25),
                                _createElementVNode("td", {
                                  class: "after-cell text-right tooltip-cell",
                                  title: item.tooltip.afterNonTax
                                }, _toDisplayString(item.after.nonTax), 9, _hoisted_26),
                                _createElementVNode("td", {
                                  class: "after-cell text-right tooltip-cell",
                                  title: item.tooltip.afterCompanyIns
                                }, _toDisplayString(item.after.companyIns), 9, _hoisted_27),
                                _createElementVNode("td", {
                                  class: "after-cell text-right tooltip-cell",
                                  title: item.tooltip.afterRetirement
                                }, _toDisplayString(item.after.retirement), 9, _hoisted_28),
                                _createElementVNode("td", {
                                  class: "after-cell text-right tooltip-cell",
                                  title: item.tooltip.afterNetPay
                                }, _toDisplayString(item.after.netPay), 9, _hoisted_29),
                                _createElementVNode("td", {
                                  class: _normalizeClass(["diff-cell text-right tooltip-cell", getDiffClass(item.diff.nonTax)]),
                                  title: item.tooltip.diffNonTax
                                }, _toDisplayString(item.diff.nonTax), 11, _hoisted_30),
                                _createElementVNode("td", {
                                  class: _normalizeClass(["diff-cell text-right tooltip-cell", getDiffClass(item.diff.companyIns, true)]),
                                  title: item.tooltip.diffCompanyIns
                                }, _toDisplayString(item.diff.companyIns), 11, _hoisted_31),
                                _createElementVNode("td", {
                                  class: _normalizeClass(["diff-cell text-right tooltip-cell", getDiffClass(item.diff.retirement, true)]),
                                  title: item.tooltip.diffRetirement
                                }, _toDisplayString(item.diff.retirement), 11, _hoisted_32),
                                _createElementVNode("td", {
                                  class: _normalizeClass(["diff-cell text-right tooltip-cell", getDiffClass(item.diff.netPay)]),
                                  title: item.tooltip.diffNetPay
                                }, _toDisplayString(item.diff.netPay), 11, _hoisted_33),
                                _createElementVNode("td", {
                                  class: _normalizeClass(["saving-cell text-right font-bold tooltip-cell", getDiffClass(item.saving, true)]),
                                  title: item.tooltip.saving
                                }, _toDisplayString(item.saving), 11, _hoisted_34)
                              ]))
                            }), 128))
                          ]),
                          _createElementVNode("tfoot", null, [
                            _createElementVNode("tr", _hoisted_35, [
                              _hoisted_36,
                              _createElementVNode("td", _hoisted_37, _toDisplayString(totals.total), 1),
                              _createElementVNode("td", _hoisted_38, _toDisplayString(totals.before.nonTax), 1),
                              _createElementVNode("td", _hoisted_39, _toDisplayString(totals.before.companyIns), 1),
                              _createElementVNode("td", _hoisted_40, _toDisplayString(totals.before.retirement), 1),
                              _createElementVNode("td", _hoisted_41, _toDisplayString(totals.before.netPay), 1),
                              _createElementVNode("td", _hoisted_42, _toDisplayString(totals.after.nonTax), 1),
                              _createElementVNode("td", _hoisted_43, _toDisplayString(totals.after.companyIns), 1),
                              _createElementVNode("td", _hoisted_44, _toDisplayString(totals.after.retirement), 1),
                              _createElementVNode("td", _hoisted_45, _toDisplayString(totals.after.netPay), 1),
                              _createElementVNode("td", {
                                class: _normalizeClass(["diff-cell text-right font-bold tooltip-cell", getDiffClass(totals.diff.nonTax)]),
                                title: totalsTooltip.nonTax
                              }, _toDisplayString(totals.diff.nonTax), 11, _hoisted_46),
                              _createElementVNode("td", {
                                class: _normalizeClass(["diff-cell text-right font-bold tooltip-cell", getDiffClass(totals.diff.companyIns, true)]),
                                title: totalsTooltip.companyIns
                              }, _toDisplayString(totals.diff.companyIns), 11, _hoisted_47),
                              _createElementVNode("td", {
                                class: _normalizeClass(["diff-cell text-right font-bold tooltip-cell", getDiffClass(totals.diff.retirement, true)]),
                                title: totalsTooltip.retirement
                              }, _toDisplayString(totals.diff.retirement), 11, _hoisted_48),
                              _createElementVNode("td", {
                                class: _normalizeClass(["diff-cell text-right font-bold tooltip-cell", getDiffClass(totals.diff.netPay)]),
                                title: totalsTooltip.netPay
                              }, _toDisplayString(totals.diff.netPay), 11, _hoisted_49),
                              _createElementVNode("td", {
                                class: _normalizeClass(["saving-cell text-right font-bold tooltip-cell", getDiffClass(totals.saving, true)]),
                                title: totalsTooltip.saving
                              }, _toDisplayString(totals.saving), 11, _hoisted_50)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_window_item, { value: "summary" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("div", _hoisted_53, [
                            _hoisted_54,
                            _createElementVNode("div", _hoisted_55, [
                              _hoisted_56,
                              _createElementVNode("span", _hoisted_57, _toDisplayString(totals.total), 1)
                            ]),
                            _createElementVNode("div", _hoisted_58, [
                              _hoisted_59,
                              _createElementVNode("span", _hoisted_60, _toDisplayString(totals.before.nonTax), 1)
                            ]),
                            _hoisted_61,
                            _createElementVNode("div", _hoisted_62, [
                              _hoisted_63,
                              _createElementVNode("span", _hoisted_64, _toDisplayString(totals.before.companyIns), 1)
                            ]),
                            _createElementVNode("div", _hoisted_65, [
                              _hoisted_66,
                              _createElementVNode("span", _hoisted_67, _toDisplayString(totals.before.retirement), 1)
                            ]),
                            _hoisted_68,
                            _createElementVNode("div", _hoisted_69, [
                              _hoisted_70,
                              _createElementVNode("span", _hoisted_71, _toDisplayString(totals.before.netPay), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_72, [
                            _hoisted_73,
                            _createElementVNode("div", _hoisted_74, [
                              _hoisted_75,
                              _createElementVNode("span", _hoisted_76, _toDisplayString(totals.total), 1)
                            ]),
                            _createElementVNode("div", _hoisted_77, [
                              _hoisted_78,
                              _createElementVNode("span", _hoisted_79, _toDisplayString(totals.after.nonTax), 1)
                            ]),
                            _hoisted_80,
                            _createElementVNode("div", _hoisted_81, [
                              _hoisted_82,
                              _createElementVNode("span", _hoisted_83, _toDisplayString(totals.after.companyIns), 1)
                            ]),
                            _createElementVNode("div", _hoisted_84, [
                              _hoisted_85,
                              _createElementVNode("span", _hoisted_86, _toDisplayString(totals.after.retirement), 1)
                            ]),
                            _hoisted_87,
                            _createElementVNode("div", _hoisted_88, [
                              _hoisted_89,
                              _createElementVNode("span", _hoisted_90, _toDisplayString(totals.after.netPay), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_91, [
                            _hoisted_92,
                            _createElementVNode("div", _hoisted_93, [
                              _hoisted_94,
                              _createElementVNode("span", _hoisted_95, _toDisplayString(comparisonData.value.length) + "명", 1)
                            ]),
                            _hoisted_96,
                            _createElementVNode("div", _hoisted_97, [
                              _hoisted_98,
                              _createElementVNode("span", {
                                class: _normalizeClass(["value", getDiffClass(totals.diff.companyIns, true)])
                              }, _toDisplayString(totals.diff.companyIns), 3)
                            ]),
                            _createElementVNode("div", _hoisted_99, [
                              _hoisted_100,
                              _createElementVNode("span", {
                                class: _normalizeClass(["value", getDiffClass(totals.diff.retirement, true)])
                              }, _toDisplayString(totals.diff.retirement), 3)
                            ]),
                            _hoisted_101,
                            _createElementVNode("div", _hoisted_102, [
                              _hoisted_103,
                              _createElementVNode("span", {
                                class: _normalizeClass(["value large", getDiffClass(totals.saving, true)])
                              }, _toDisplayString(totals.saving), 3)
                            ]),
                            _createElementVNode("div", _hoisted_104, [
                              _hoisted_105,
                              _createElementVNode("span", {
                                class: _normalizeClass(["value", getDiffClass(totals.saving, true)])
                              }, _toDisplayString(totals.yearSaving), 3)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : (!loadingBasic.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_106, _hoisted_108))
            : (_openBlock(), _createElementBlock("div", _hoisted_109, _hoisted_111)),
        _createElementVNode("div", _hoisted_112, [
          _createVNode(_component_v_btn, {
            class: "cancelRegistBtn",
            onClick: closeDialog
          }, {
            default: _withCtx(() => [
              _createTextVNode("닫기")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})